import type { SettingsSearchEntry } from './settings-search.config';

/**
 * Dynamic entries are not in the static manifest, so the surface selecting
 * one publishes that exact entry before changing the settings hash. This is a
 * one-shot handoff to `useSettingsDeepLink`, not a second cache of provider
 * data; the sidebar and command palette therefore cannot invalidate each
 * other's visible results.
 */
let pendingDeepLinkEntry: SettingsSearchEntry | null = null;
let pendingEntryTimer: ReturnType<typeof setTimeout> | null = null;
const PENDING_ENTRY_TTL_MS = 10_000;

export const registerPendingSettingsDeepLink = (
  entry: SettingsSearchEntry
): void => {
  if (pendingEntryTimer) clearTimeout(pendingEntryTimer);
  pendingDeepLinkEntry = entry;
  pendingEntryTimer = setTimeout(() => {
    if (pendingDeepLinkEntry === entry) pendingDeepLinkEntry = null;
    pendingEntryTimer = null;
  }, PENDING_ENTRY_TTL_MS);
};

export const findPendingSettingsDeepLink = (
  itemId: string,
  sectionId: string
): SettingsSearchEntry | null =>
  pendingDeepLinkEntry?.id === itemId &&
  pendingDeepLinkEntry.sectionId === sectionId
    ? pendingDeepLinkEntry
    : null;

export const clearPendingSettingsDeepLink = (
  entry: SettingsSearchEntry
): void => {
  if (pendingDeepLinkEntry !== entry) return;
  pendingDeepLinkEntry = null;
  if (pendingEntryTimer) clearTimeout(pendingEntryTimer);
  pendingEntryTimer = null;
};
